"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardSetSearchDto = exports.StandardSetStatus = void 0;
var StandardSetStatus;
(function (StandardSetStatus) {
    StandardSetStatus["COMPLETE"] = "complete";
    StandardSetStatus["INCOMPLETE"] = "incomplete";
})(StandardSetStatus || (exports.StandardSetStatus = StandardSetStatus = {}));
class StandardSetSearchDto {
}
exports.StandardSetSearchDto = StandardSetSearchDto;
//# sourceMappingURL=standards-set-search.dto.js.map